import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/content";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleJump = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 border-b border-background-200/80 backdrop-blur" : "bg-transparent"
      }`}
    >
      <nav className="flex h-16 items-center justify-between px-4 md:px-8">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 cursor-pointer"
          aria-label="回到爱情岛首页顶部"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-heart-3-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-semibold tracking-wide text-foreground-950">爱情岛</span>
        </button>

        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <button
              key={link.id}
              type="button"
              onClick={() => handleJump(link.id)}
              className="font-label text-sm text-foreground-700 transition-colors hover:text-primary-600 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
        </div>

        <button
          type="button"
          onClick={() => handleJump("articles")}
          className="hidden md:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 font-label text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-book-open-line"></i>
          开始阅读
        </button>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 cursor-pointer"
          aria-label="打开导航菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <button
                key={link.id}
                type="button"
                onClick={() => handleJump(link.id)}
                className="flex items-center justify-between border-b border-background-200/70 py-3 text-left font-label text-sm text-foreground-800 cursor-pointer"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => handleJump("articles")}
            className="mt-4 w-full rounded-md bg-primary-500 py-2.5 font-label text-sm text-background-50 cursor-pointer"
          >
            开始阅读情感文章
          </button>
        </div>
      )}
    </header>
  );
}